import { render, staticRenderFns } from "./CustomerUserCreate.vue?vue&type=template&id=f3025878"
import script from "./CustomerUserCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerUserCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports